import actionSoundFile from "../assets/sound/universfield.mp4";
import { playAppSound } from "./playAppSound";

export const playActionSound = async () => {
  await playAppSound(actionSoundFile).catch((err) =>
    console.error("Audio play error (action):", err),
  );
};
